let nodeIdCounter = 1;

export function expressionTreeToFlowData(
  tree,
  parentId = null,
  nodes = [],
  edges = []
) {
  if (!tree) return { nodes, edges };

  const nodeId = `node-${nodeIdCounter++}`;

  // create the node
  nodes.push({
    id: nodeId,
    type: "default",
    data: {
      label: tree.expression || tree.value || "<empty>",
      type: tree.type,
      op: tree.op || null,
      value: tree.expression || tree.value || null,
    },
    position: { x: 100, y: 20 },
  });

  // create edge from parent to this node
  if (parentId) {
    edges.push({
      id: `e-${parentId}-${nodeId}`,
      source: parentId,
      target: nodeId,
      animated: true,
    });
  }

  // recurse for children
  if (tree.args && tree.args.length > 0) {
    tree.args.forEach((child) => {
      expressionTreeToFlowData(child, nodeId, nodes, edges);
    });
  }

  return { nodes, edges };
}
